import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import { message, Modal } from "antd";
import { EntTradeRegistry } from "../../../../models/organic/tradeRegistry";
import {
  useAddTradeRegistryMutation,
  useDeleteTradeRegistryMutation,
  useEditTradeRegistryMutation
} from "../../../../redux/api/organic/tradeRegistryApi";

const useTradeRegistry = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation();
  const { confirm } = modal;
  const [addTradeRegistry] = useAddTradeRegistryMutation();
  const [deleteTradeRegistry] = useDeleteTradeRegistryMutation();
  const [editTradeRegistry] = useEditTradeRegistryMutation();

  async function onAddTradeRegistry(newTradeRegistry: EntTradeRegistry): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addTradeRegistry(newTradeRegistry).then((response: any) => {
		if (response.error) {
		  const isKyrgyz = getCookie('i18next') === 'ky';
		  const lang = isKyrgyz ? 'kg' : 'ru';
		  const res = response.error.data?.res;
		  const errorMessages = Array.isArray(res)
			? res.map((error: any) => error[lang] || error.ru).join('\n')
			: response.error.data?.msg || t('unknownError');
		  throw new Error(errorMessages);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }


  async function onDeleteTradeRegistry(tradeRegistry: EntTradeRegistry) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteTradeRegistry(tradeRegistry.id as number).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(`${ response.error.data.res.kg } / ${ response.error.data.res.ru }`);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onEditTradeRegistry(editedTradeRegistry: EntTradeRegistry): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editTradeRegistry(editedTradeRegistry).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(`${ response.error.data.res.kg } / ${ response.error.data.res.ru }`);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  };

  return { onAddTradeRegistry, onDeleteTradeRegistry, onEditTradeRegistry };

}

export { useTradeRegistry };

